import { NgModule } from '@angular/core';

import { MessageBox } from './components/message-box';
import { Message } from './message';

/**
 * Exposes the Message and MessageBox.
 * @deprecated Import `Message` and `MessageBox` directly, they are standalone components.
 */
@NgModule({
  imports: [Message, MessageBox],
  exports: [Message, MessageBox]
})
export class CelumMessageModule {}
